import EventEmitter from 'src/helpers/EventEmitter'
import EventObserver from 'src/helpers/EventObserver' 

class Communicator { 
  constructor() {
    Object.assign(this, EventEmitter)
    Object.assign(this, EventObserver) 
  }
}

export default new Communicator()